import {match} from 'ts-pattern';

import {isEmpty} from 'ramda';

import {TimeType} from '../../../types/TimeType';

const NON_DIGIT_REGEX = /\D/g;

const normalizeDigits = (value: string) => value.replace(NON_DIGIT_REGEX, '');

/**
 * Bare-hour ("9") and H:mm-without-separator ("930") queries also match their
 * zero-padded forms so they line up with the always-4-digit option values.
 */
const getQueryCandidates = (queryDigits: string) =>
  match(queryDigits.length)
    .with(1, 3, () => [queryDigits, `0${queryDigits}`])
    .otherwise(() => [queryDigits]);

export function filterTimeOptions(
  options: TimeType[],
  query: string,
  formatTimeLabel: (time: TimeType) => string
): TimeType[] {
  const queryDigits = normalizeDigits(query);
  if (isEmpty(queryDigits)) {
    return options;
  }

  // A separator means the user is typing the visual format ("2:0" → "2:00 PM"),
  // so the locale-formatted label participates; digit-only queries stay 24h to
  // keep "14" from matching "1:45".
  const hasSeparator = queryDigits.length !== query.trim().length;
  const candidates = getQueryCandidates(queryDigits);

  return options.filter((option) => {
    const optionDigits = normalizeDigits(option);
    const matchesValueDigits = candidates.some((candidate) => optionDigits.startsWith(candidate));
    const matchesLabel =
      hasSeparator && normalizeDigits(formatTimeLabel(option)).startsWith(queryDigits);
    return matchesValueDigits || matchesLabel;
  });
}
